<template>
  <v-container fluid class="lighten-3 fill-height pa-0">
    <!-- left: 左侧需要固定并且内部可以滚动 -->
    <div
      v-show="leftVisible"
      id="leftBlock"
      style="position: fixed; width: 30%; height: 100%; overflow: auto"
      class="d-print-none"
    >
      <v-card tile style="min-height: 100%">
        <v-card-text class="pa-0">
          <v-treeview
            v-if="chapterTreeData.length"
            dense
            :items="chapterTreeData"
            open-all
            activatable
            item-key="id"
            @update:active="onChapterTreeUpdateActive"
            :active.sync="chapterSelectedRows"
            return-object
          >
            <template v-slot:label="{ item }"
              ><span class="font-weight-black mr-1">{{ item._cno }}</span
              >{{ item.name }}</template
            >
          </v-treeview>
        </v-card-text>
      </v-card>
    </div>
    <!-- spliter -->
    <div
      v-show="leftVisible"
      id="spliter"
      style="
        cursor: col-resize;
        width: 5px;
        background-color: #757575;
        position: fixed;
        left: 30%;
        height: 100%;
      "
      class="d-print-none"
    ></div>

    <!-- right: 右侧需要全局滚动以配合打印 -->
    <div
      id="rightBlock"
      style="
        width: 70%;
        position: absolute;
        left: 30%;
        margin-left: 5px;
        height: 100%;
      "
    >
      <!-- 封面cover -->
      <cover-chapter v-if="reportData" :param="coverParam"></cover-chapter>
      <!-- <div style="page-break-after:always;-moz-page-break-after:always;"></div> -->

      <!-- 目录 -->
      <!-- <menu-chapter v-if="chapterTreeData.length" :items="chapterTreeData"></menu-chapter> -->
      <!-- <div style="page-break-after:always;-moz-page-break-after:always;"></div> -->
      <!-- 各个章节 -->
      <div v-if="cps.length">
        <template v-for="(cp, index) in cps">
          <a :name="`anchor_${cp._cno}`" :key="`anchor_${index}`"></a>
          <div
            v-if="cp._cno.split('.').length == 1"
            class="title-h1 background"
            :key="`chapter_${index}`"
            :ref="`chapter_${index}`"
          >
            {{ cp._cno }}<span class="ml-1">{{ cp.name }}</span>
          </div>
          <div
            v-else-if="cp._cno.split('.').length == 2"
            class="title-h2"
            :key="`chapter_${index}`"
            :ref="`chapter_${index}`"
          >
            {{ cp._cno }}<span class="ml-1">{{ cp.name }}</span>
          </div>
          <div
            v-else-if="cp._cno.split('.').length == 3"
            class="title-h3"
            :key="`chapter_${index}`"
            :ref="`chapter_${index}`"
          >
            {{ cp._cno }}<span class="ml-1">{{ cp.name }}</span>
          </div>
          <div
            v-else-if="cp._cno.split('.').length == 4"
            class="title-h4"
            :key="`chapter_${index}`"
            :ref="`chapter_${index}`"
          >
            {{ cp._cno }}<span class="ml-1">{{ cp.name }}</span>
          </div>
          <content-chapter
            v-if="!!cp.htmlFile"
            :key="index"
            :ref="`ec_${index}`"
            :debug="isDebug"
            :chapter="cp"
            :param="cpp[index]"
            class="pl-8 pr-8"
          />
        </template>
      </div>
    </div>

    <!-- loading -->
    <v-dialog v-if="!ready" v-model="loadingVisible" persistent max-width="450">
      <v-card min-height="200">
        <v-card-title>
          <v-icon class="mdi-spin mr-2">mdi-timer-sand</v-icon>
          耗时操作，请耐心等待...
        </v-card-title>
        <v-card-text class="pl-6 pr-6">
          <v-row justify="end">
            <v-col cols="12">
              <v-progress-linear
                striped
                color="deep-orange"
                :value="loadedPercent"
                height="35"
              >
                <strong>{{ cpsLoadNum == 0 ? 0 : loadedPercent }} %</strong>
              </v-progress-linear>
            </v-col>
            <v-col cols="auto">
              <span class="overline" v-if="cps.length">
                正在加载: {{ cpsLoadTip }}
              </span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- 显示/隐藏导航栏 -->
    <v-btn
      @click="toggleLeft"
      fab
      dark
      color="orange"
      x-small
      left
      fixed
      style="top: 50%; opacity: 0.85; left: 0"
      class="d-print-none"
    >
      <v-icon small>{{
        leftVisible ? "mdi-arrow-collapse-left" : "mdi-arrow-collapse-right"
      }}</v-icon>
    </v-btn>

    <!-- 在线客服 -->
    <div
      v-if="onlineServiceShow"
      style="position: fixed; bottom: 165px; right: 16px"
      class="d-print-none"
    >
      <v-icon
        color="grey"
        small
        style="position: absolute; top: -10px; right: -5px"
        @click="onCloseOnlineService"
        >mdi-close</v-icon
      >
      <v-img
        style="cursor: pointer"
        @click="onOnlineService"
        :src="`${Utility.RES_SERVER}/static/img/online-service.png`"
        width="64"
        contain
      ></v-img>
    </div>

    <!-- 导出pdf -->
    <v-btn
      v-if="cf"
      @click="onExport"
      fab
      dark
      color="purple"
      right
      fixed
      large
      style="bottom: 90px; opacity: 0.85"
      class="d-print-none"
    >
      <v-icon large>mdi-file-pdf-outline</v-icon>
    </v-btn>

    <!-- 回到顶部 -->
    <v-btn
      v-show="backTopShow"
      @click="backTop"
      fab
      dark
      color="primary"
      bottom
      right
      fixed
      large
      style="opacity: 0.85"
      class="d-print-none"
    >
      <v-icon>mdi-arrow-collapse-up</v-icon>
    </v-btn>

    <!-- 报告确认提示 -->
    <template v-if="!cf && ready && isPreviewReport">
      <div
        style="
          top: 0;
          width: 100%;
          position: fixed;
          z-index: 99;
          opacity: 0.8;
        "
        class="px-4"
      >
        <v-alert
          v-model="tipVisible"
          dismissible
          border="right"
          height="100%"
          colored-border
          type="error"
          elevation="4"
        >
          <v-row dense class="caption">
            <v-col cols="12">尊敬的老师您好：</v-col>
            <v-col cols="12">您当前正在浏览的是项目“{{htbh}}+{{projectInfo.xmmc}}”的结题报告。</v-col>
            <!-- <v-col cols="12">点击“确认无误”后，可下载报告。</v-col> -->
            <v-col cols="12">温馨提示：结题报告仅是部分结果的展示，为了维护您的权益，保障数据交付准确无误，需要您点击下方按钮进行结算确认。在款项充足的条件下，我司将在结算确认后安排完整报告，交互分析（仅限动态交互类）和原始数据的释放，且此后项目进入售后阶段。</v-col>
            <v-col cols="auto" class="pt-2">
              <v-btn large color="primary" @click="onConfirm">结算确认</v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </div>
      <v-btn
        @click="tipVisible = true"
        v-if="!tipVisible"
        icon
        fab
        dark
        color="error"
        right
        fixed
        style="top: 10px; opacity: 0.85; z-index: 99"
      >
        <v-icon large>mdi-information</v-icon>
      </v-btn>
    </template>

    <!-- 结算确认弹出框 --> 
    <confirm v-model="showConfirm" :data="projectInfo" v-on="$listeners" />
  </v-container>
  
</template>
<script>
// , getReportChapterContent
import {
  getReport,
  getReportChapter,
  getReportChapterPreview,
  userFileRead,
  asgLtcProjectDetail,
  // userProjectConfirm,
} from "@/plugins/api";
import confirm from "./confirm.vue";
import ContentChapter from "./ContentChapter.vue";
import CoverChapter from "./CoverChapter.vue";
// import MenuChapter from './MenuChapter.vue';
import activeSpliter from "@/assets/spliter/Spliter.js";
let llw, lrw; // 最后记录的左侧宽度与右侧宽度
// import jsPDF from 'jspdf';

export default {
  data() {
    return {
      projectInfo: {},

      reportId: null,
      xmfah: null,
      xmh: null,
      htbh: null,
      schema: null,
      id: null, // OA项目id

      reportData: null,
      sps: [],

      ready: false,
      leftVisible: true,
      loadingVisible: true,
      chapterIndex: 0,
      chapters: [],
      chapterTreeData: [],
      chapterContents: [],

      chapterSelectedRows: [],

      backTopShow: false,
      // 对接在线客服
      onlineServiceShow: false,

      cpsTotal: [],
      cps: [],
      cpp: [], // 章节参数
      cpsNum: 0,
      cpsLoadNum: 0,
      cpsLoadTip: "",
      tipVisible: true,

      isDebug: false,
      showConfirm: false,
    };
  },
  computed: {
    coverParam() {
      return {
        type: this.reportData.type,
        xmh: this.xmh,
        schema: this.schema,
        xmwcrq: this.projectInfo.xmwcrq,
      };
    },
    loadedPercent() {
      return parseInt((this.cpsLoadNum / this.cpsNum) * 100);
    },
    cf() {
      return this.projectInfo.cf;
    },
    zt() {
      return this.projectInfo.zt;
    },
    // 判断是否管理端
    isManage() {
      const query = this.$route.query;
      return query.endType === "manage" ? true : false;
    },
    // 判断是否预览版报告
    isPreviewReport() {
      const query = this.$route.query;
      return query.preview === "1" ? true : false;
    },
  },
  watch: {
    ready(v) {
      if (v) {
        window.addEventListener("scroll", this.handleScroll);
        activeSpliter(200, 500);
      }
    },
    chapterSelectedRows(v) {
      this.scrollTo(v[0].id);
    },
  },
  async created() {
    await this.init();
  },
  methods: {
    async init() {
      this.reportId = this.$route.query.reportId;
      this.xmfah = this.$route.query.xmfah;
      this.htbh = this.$route.query.htbh;
      this.xmh = this.$route.query.xmh;
      this.schema = this.$route.query.schema;
      this.isDebug = this.$route.query.debug;
      this.id = this.$route.query.id;
      this.preview = this.$route.query.preview;
      this.internalReview = this.$route.query.endType === "manage" ? true : false;
      const params = {
        projectNo: this.xmfah
      }
      if(!this.isDebug) await asgLtcProjectDetail(params).then(res => this.projectInfo = res.data);
      else this.projectInfo = {cf:true}
      if(!this.internalReview && !this.preview){ //非内部审核预览，非客户预览结题报告
        if(this.projectInfo.previewFlag) {//有结题报告的项目
          if(this.projectInfo.cf == 0 || this.projectInfo.zt < 2) {
            //如果项目为确认或zt < 2，不能预览正式报告
            return;
          }
        } else {//无结题报告的项目
          if(this.projectInfo.zt < 2) {
            //如果项目zt < 2，不能预览正式报告
            return;
          }
        }
      }  
      await getReport(this.reportId, false).then(res => this.reportData = res.data);
      await this.loadReportChapter();
      await this.loadSps();
      this.$nextTick(this.initReport);
    },
    initNo() {
      let cnt = 1;
      let process = (arr, pNo) => {
        for (let i = 0; i < arr.length; i++) {
          arr[i]._cno = pNo ? pNo + "." + (i + 1) : String(i + 1);
          arr[i]._sno = cnt++;
          if (arr[i].children && arr[i].children.length)
            process(arr[i].children, arr[i]._cno);
        }
      };
      process(this.chapterTreeData);
    },
    async loadReportChapter() {
      // 获取在线报告章节
      let f = getReportChapter;
      if(this.preview){ //预览版报告
         f = getReportChapterPreview;
      }
      await f(this.reportId).then((res) => {
        let cps = res.data;
        let name = this.$route.query.name;
        if (name) {
          let names = name.split(",");
          cps = cps.filter((c) => names.indexOf(c.name) != -1);
        }
        this.chapters = cps;
        let treeData = this.Utility.toTree(cps, "id", "pid");
        this.chapterTreeData = treeData;
        this.initNo();
      });
    },
    async loadSps() {
      // 加载样品信息
      await userFileRead({
        path: `/${this.reportData.type}/${this.xmh}/Result/${this.schema}/Design/Sample.xlsx`,
      }).then((res) => {
        let d = res.data;
        if (d) d.slice(1).forEach((row) => this.sps.push(row[1]));
      });
    },
    async initReport() {
      let rows = this.Utility.flatTree(this.chapterTreeData);
      let cps = rows.sort((a, b) => (a._sno > b._sno ? 1 : -1));
      for (let i = 0, l = cps.length; i < l; i++) {
        let cp = cps[i];
        this.cpp.push({
          type: this.reportData.type,
          xmh: this.xmh,
          schema: this.schema,
          task: null,
          sps: this.sps,
          vsList: [],
          readonly: true,
          vsMap: {},
        });
        this.cpsTotal.push(cp);
        if (cp.htmlFile) this.cpsNum++;
      }
      let cp = this.cpsTotal[0];
      this.cps.push(cp);
      this.cpsLoadTip = cp._cno + " " + cp.name;
    },
    async setReadyState() {
      // if (this.cpsLoadNum >= 8) {
      //   this.ready = true;
      //   this.loadingVisible = false;
      //   return;
      // }
      // ------------- debug

      this.cpsLoadNum++;
      let next = this.cpsTotal[this.cpsLoadNum];
      if (!next) {
        if (this.cpsLoadNum >= this.cpsNum) {
          this.ready = true;
          this.loadingVisible = false;
        }
        return;
      }

      await this.$nextTick().then(() => {
        this.cps.push(next);
        this.cpsLoadTip = next._cno + " " + next.name;
        if (this.cpsLoadNum >= this.cpsNum) {
          this.ready = true;
          this.loadingVisible = false;
        }
        if (!next.htmlFile) this.setReadyState();
      });
    },

    onChapterTreeUpdateActive(rows) {
      if (!rows.length) rows.push(this.chapterSelectedRows[0]);
    },
    onExport() {
      let srcVisible = this.leftVisible;
      document
        .getElementsByClassName("report-hide")
        .forEach((el) => (el.style.display = "none"));
      if (this.leftVisible) this.toggleLeft();
      this.$nextTick(() => {
        window.print();
        document
          .getElementsByClassName("report-hide")
          .forEach((el) => (el.style.display = "block"));
        if (srcVisible) this.toggleLeft();
      });
    },

    // ================ 在线客服
    onCloseOnlineService() {
      this.onlineServiceShow = false;
    },
    onOnlineService() {},

    // ================ 页面的滚动
    backTop() {
      let back = setInterval(() => {
        if (document.body.scrollTop || document.documentElement.scrollTop) {
          document.body.scrollTop -= 200;
          document.documentElement.scrollTop -= 200;
        } else {
          clearInterval(back);
        }
      });
    },
    handleScroll() {
      if (document.documentElement.scrollTop + document.body.scrollTop > 200) {
        this.backTopShow = true;
      } else {
        this.backTopShow = false;
      }
    },
    scrollTo(id) {
      let cpr = this.cps.find((c) => c.id == id);
      let index = this.cps.indexOf(cpr);
      window.scrollTo({
        top: this.$refs[`chapter_${index}`][0].offsetTop - 100,
        behavior: "smooth",
      });
    },

    toggleLeft() {
      this.leftVisible = !this.leftVisible;
      if (this.leftVisible) {
        document.getElementById("leftBlock").style.width = llw + "px";
        document.getElementById("spliter").style.left = llw + "px";
        document.getElementById("rightBlock").style.left = llw + "px";
        document.getElementById("rightBlock").style.width = lrw + "px";
      } else {
        llw = document.getElementById("leftBlock").offsetWidth;
        lrw = document.getElementById("rightBlock").offsetWidth;
        document.getElementById("rightBlock").style.left = 0;
        document.getElementById("rightBlock").style.width = "100%";
      }
    },

    // ================ 报告确认
    onConfirm() {
      // userProjectConfirm(
      //   this.projectInfo.id,
      //   this.projectInfo.xmfah,
      //   this.projectInfo.htbh
      // ).then(() => {
      //   this.$message.success("报告确认完成,3秒后页面自动重新加载");
      //   setTimeout(() => location.reload(), 3000);
      // });
      this.showConfirm=true;
      this.tipVisible=false;
    },
  },
  components: { ContentChapter, CoverChapter, confirm },
  // components: { ContentChapter, CoverChapter, MenuChapter }
};
</script>

<style lang="scss" scoped>
@mixin font {
  font-weight: 500;
  line-height: 1.1;
  color: #065fae;
  font-family: inherit;
}
.title-h1 {
  @include font;
  font-size: 30px;
  font-weight: 700;
}
.title-h2 {
  @include font;
  font-size: 24px;
}
.title-h3 {
  @include font;
  font-size: 20px;
}
.title-h4 {
  @include font;
  font-size: 18px;
}

.background {
  background: no-repeat url("~@/assets/image/title_bg.png") right bottom;
  background-size: contain;
  padding: 15px 0;
}
</style>
